var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Ui-DetailButton"},[_c('div',{staticClass:"cover"},[_c('router-link',{attrs:{"to":("" + _vm.path)}},[_c('div',{staticClass:"button"},[_c('p',[_vm._v(_vm._s(_vm.link))]),_c('div',{staticClass:"arrow"})])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }